import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../../services/api";
import { useToast } from "../../contexts/toast/toast-context";
import { getApiErrorMessage } from "../../utils";
import { LoadingButton } from "../../components/button/loading-button";

export function ResetPassword() {
  const navigate = useNavigate();
  const { success, error } = useToast();

  const [params] = useSearchParams();
  const token = params.get("token");

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleReset() {
    if (loading) return;
    if (newPassword !== confirmPassword) {
      return error("As senhas não coincidem!");
    }

    try {
      setLoading(true);
      await api.post("/auth/reset-password", { token, newPassword });
      success("Senha redefinida com sucesso!");
      navigate("/login");
    } catch (err) {
      const apiMessage = getApiErrorMessage(err);
      error(apiMessage);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="relative flex min-h-screen items-center justify-center bg-cover bg-center px-4 py-10">
      <div className="absolute inset-0 bg-blue-950/70" />
      <div className="absolute inset-0 bg-grid opacity-20" />

      <div className="app-card-elevated relative z-10 w-full max-w-md bg-white/95 p-8 backdrop-blur-sm">
        <div className="mb-6 flex flex-col items-center justify-center">
          <img
            src="/img/sengia-logo-horizontal.png"
            alt="Sengia"
            className="mb-4 h-auto w-full max-w-[260px]"
          />
          <h1 className="text-xl font-semibold text-slate-900">
            Redefinir senha
          </h1>
        </div>

        <input
          type="password"
          placeholder="Nova senha"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          className="form-input mb-4"
          autoComplete="new-password"
        />

        <input
          type="password"
          placeholder="Confirmar senha"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          className="form-input mb-4"
          autoComplete="new-password"
        />

        <LoadingButton
          onClick={handleReset}
          className="btn btn-primary w-full"
          isLoading={loading}
          loadingLabel="Enviando"
        >
          Redefinir senha
        </LoadingButton>
      </div>
    </div>
  );
}
